<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        advanced
        :resource="$sdk.ratecard"
        :primary-fields="[ 'carrier', 'group.indices.account', 'type', 'date_start', 'date_end', 'active', 'charge_account' ]"
        :setup-fields="{ date_end: setupDateEndFilterable }"
        :hidden-fields="[ 'group' ]"
        @sort="sort = $event; $refs.table.loadTable()"
        @ready="$refs.table.loadTable()"
        @apply="$refs.table.loadTable()"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        shadow="never"
      >
        <RateCardsTable
          ref="table"
          :filters="filters"
          :sort="sort"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import RateCardsTable from '@/components/Application/Manage/RateCards/RateCardsTable'
import { IS_GREATER_THAN } from '@/plugins/sdk/Filter'

export default {
  components: {
    Filters,
    RateCardsTable
  },
  data () {
    return {
      title: 'Rate Cards',
      breadcrumb: {
        name: 'Rate Cards',
        route: { name: 'manage-ratecards' }
      },
      actions: [],
      filters: [],
      sort: {
        field: 'name',
        direction: 'asc'
      }
    }
  },
  mounted () {
    this.actions = this.$refs.table.actions
  },
  methods: {
    setupDateEndFilterable (filterable) {
      filterable.filter.operator = IS_GREATER_THAN
      filterable.filter.value = this.$moment().startOf('day').toDate()
    }
  }
}
</script>
